import { Component, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { ClarityCallPopupComponent } from '../../shared/components/clarity-call-popup/clarity-call-popup.component';
import { ContactPurpose } from '../../models/enums/contactUs';
import { InstituteService } from '../../services/institute/institute.service';
import { forkJoin, catchError, of } from 'rxjs';
@Component({
  selector: 'app-direct-apply',
  standalone: true,
  imports: [CommonModule, RouterModule, ClarityCallPopupComponent],
  templateUrl: './direct-apply.component.html',
  styleUrl: './direct-apply.component.scss'
})
export class DAComponent implements AfterViewInit, OnDestroy { 
  showClarityPopup = false;
  ContactPurpose = ContactPurpose;
  @ViewChild('testimonialContainer') testimonialContainer!: ElementRef;
  animationFrameId: number | null = null;
  isPaused = false;
  partnerUniversitiesCount: string = '';

  constructor(private router: Router, private instituteService: InstituteService) {}

intakeYear: string = '';

  ngOnInit() {

     const currentYear = new Date().getFullYear();
  const startYear = currentYear + 1;
  const endYear = startYear + 1;

  this.intakeYear = `${startYear}-${endYear.toString().slice(-2)}`;
  
    // Fetch both DA Abroad partners and DA India partners in parallel, then sum
    forkJoin([
      this.instituteService.getFilterCounts({ isForCourse: false }).pipe(catchError(() => of(null))),
      this.instituteService.instituteDetailSearch({ isDAPartner: true, country: 'India', pageNumber: 1, pageSize: 1 }).pipe(catchError(() => of(null)))
    ]).subscribe(([abroadRes, indiaRes]) => {
      const abroadCount = (abroadRes as any)?.partnerCount ?? (abroadRes as any)?.result?.partnerCount ?? 0;
      const indiaCount = (indiaRes as any)?.total ?? (indiaRes as any)?.result?.total ?? 0;
      this.partnerUniversitiesCount = abroadCount + indiaCount;
    });
  }

  startStandardApply() {
    sessionStorage.removeItem('da_mode');
    this.router.navigate(['/portal/institute-search'], { queryParams: { tab: 'universities', isDAPartner: true } });
  }

  startExpertApply() {
    sessionStorage.setItem('da_mode', 'expert');
    this.router.navigate(['/portal/direct-apply'], { queryParams: { step: 1 } });
  }

  logos: string[] = [
    '../../../assets/images/university-icons/direct-apply/1.png',
    '../../../assets/images/university-icons/direct-apply/2.png',
    '../../../assets/images/university-icons/direct-apply/3.png',
    '../../../assets/images/university-icons/direct-apply/4.png',
    '../../../assets/images/university-icons/direct-apply/5.png',
    '../../../assets/images/university-icons/direct-apply/6.png',
    '../../../assets/images/university-icons/direct-apply/7.png',
    '../../../assets/images/university-icons/direct-apply/8.png',
  ];
  extendedLogos: string[] = [...this.logos, ...this.logos];

  testimonials = [
    {
      text: "Fit's been an overwhelming few days, with the move etc. Secondly, and more importantly, thank you so very much for your email and the song. I truly appreciate the belief you've shown in my abilities throughout this process, and it is partly because of that that I could get whatever admits I got. You've made a world of a difference for me, and I'm so glad we got to work together. Thank you again",
      name: "Divisha",
      subtext: "ISB, Boston University",
      avatarColor: "#F7B801",
      avatarText: "D",
      avatarTextColor: "white",
      bgColor: "#FEF8E5",
      borderColor: "#FDEAB2",
      quoteColor: "#F7B801",
      badgeText: "5 ★",
      badgeBgColor: "#F7B801",
      badgeTextColor: "#000086"
    },
    {
      text: "I'm thrilled to share my admission to the Master of Engineering program at Cornell University for Fall 2026. A huge thank you to the Grad Pilots team for their invaluable support in helping me join Cornell’s Engineering Management program in Ithaca. I couldn't have achieved this milestone without you!",
      name: "Aryan",
      subtext: "ME, Cornell University",
      avatarColor: "#CDD12A",
      avatarText: "A",
      avatarTextColor: "#000086",
      bgColor: "#FAFAE9",
      borderColor: "#E1E37F",
      quoteColor: "#CDD12A",
      badgeText: "Top Pick",
      badgeBgColor: "#CDD12A",
      badgeTextColor: "#000086"
    },
    {
      text: "Grad Pilots really transformed my application journey. Their personalized mentoring approach helped me secure a spot at my dream university. The insights into the essays and interviews were absolutely game-changing. I highly recommend them to anyone aiming for top schools!",
      name: "Priya",
      subtext: "MBA, Stanford University",
      avatarColor: "#F7B801",
      avatarText: "P",
      avatarTextColor: "white",
      bgColor: "#FEF8E5",
      borderColor: "#FDEAB2",
      quoteColor: "#F7B801",
      badgeText: "5 ★",
      badgeBgColor: "#F7B801",
      badgeTextColor: "#000086"
    },
    {
      text: "The structure and guidance provided by the team took away all my anxiety. From shortlisting universities to finalizing my SOP, every step was meticulously planned. I couldn't have asked for a better support system during this stressful process.",
      name: "Rahul",
      subtext: "MS CS, Carnegie Mellon",
      avatarColor: "#CDD12A",
      avatarText: "R",
      avatarTextColor: "#000086",
      bgColor: "#FAFAE9",
      borderColor: "#E1E37F",
      quoteColor: "#CDD12A",
      badgeText: "Top Pick",
      badgeBgColor: "#CDD12A",
      badgeTextColor: "#000086"
    },
    {
      text: "Mam is a complete goddess! She helps with everything related to the application system, and makes sure you only submit your file when it's at it's best! Without her I wouldn't be in such a great University! Hands down recommend her! I Trust her blindly!",
      name: "Arsh",
      subtext: "Ex Vasant Valley School - McGill University",
      avatarColor: "#F7B801",
      avatarText: "A",
      avatarTextColor: "white",
      bgColor: "#FEF8E5",
      borderColor: "#FDEAB2",
      quoteColor: "#F7B801",
      badgeText: "Scholarship",
      badgeBgColor: "#F7B801",
      badgeTextColor: "#000086"
    },
    {
      text: "The experience is synonymous with perfection. It's like ma'am and sir put your dreams into perspective for you and help you achieve them. Everything happens with utmost precision. They are the best team, their advice is very precious and they'll treat you like family. They know what they do. I got admitted to all my dream Universities thanks to their combined effort and hard work. Cheers to them!",
      name: "Lavanya",
      subtext: "Ex Modern School - University of Toronto",
      avatarColor: "#CDD12A",
      avatarText: "L",
      avatarTextColor: "#000086",
      bgColor: "#FAFAE9",
      borderColor: "#E1E37F",
      quoteColor: "#CDD12A",
      badgeText: "Scholarship",
      badgeBgColor: "#CDD12A",
      badgeTextColor: "#000086"
    },
    {
      text: "Ma'am was the first person, apart from my family, who instilled in me the confidence that it was possible, and that I could indeed get into top universities in the short time span we had. We worked together for over a month.",
      name: "Aishani",
      subtext: "Babson (Mass) USA",
      avatarColor: "#F7B801",
      avatarText: "A",
      avatarTextColor: "white",
      bgColor: "#FEF8E5",
      borderColor: "#FDEAB2",
      quoteColor: "#F7B801",
      badgeText: "5 ★",
      badgeBgColor: "#F7B801",
      badgeTextColor: "#000086"
    },
    {
      text: "Maam and sir are two of the best people to have by your side if you're thinking of applying to US or Canada. If you're hesitant or confused about your dream of studying abroad then stop overthinking.",
      name: "Sanat",
      subtext: "Ex Modern School, Barakhamba Road - UBC",
      avatarColor: "#CDD12A",
      avatarText: "S",
      avatarTextColor: "#000086",
      bgColor: "#FAFAE9",
      borderColor: "#E1E37F",
      quoteColor: "#CDD12A",
      badgeText: "Top Pick",
      badgeBgColor: "#CDD12A",
      badgeTextColor: "#000086"
    }
  ];

  extendedTestimonials = [...this.testimonials, ...this.testimonials];

  admits = [
    { flag: 'USA.svg', alt: 'USA', target: 50, count: 0, suffix: '+', country: 'UNITED STATES', unis: 'MIT, Stanford, CMU & more' },
    { flag: 'UK.svg', alt: 'UK', target: 30, count: 0, suffix: '+', country: 'UNITED KINGDOM', unis: 'Oxford, Imperial, UCL & more' },
    { flag: 'CANADA.svg', alt: 'Canada', target: 60, count: 0, suffix: '+', country: 'CANADA', unis: 'UBC, Toronto, Waterloo & more' },
    { flag: 'EUROPE.svg', alt: 'Europe', target: 20, count: 0, suffix: '+', country: 'EUROPE', unis: 'TU Munich, RWTH, HPI & more' },
    { flag: 'INDIA.svg', alt: 'India', target: 40, count: 0, suffix: '+', country: 'INDIA', unis: 'NUS, NTU, SMU & more' },
    { flag: 'AUSTRALIA.svg', alt: 'Australia', target: 20, count: 0, suffix: '+', country: 'AUSTRALIA', unis: 'Melbourne, UNSW, ANU & more' },
    { flag: 'SINGAPORE.svg', alt: 'Singapore', target: 10, count: 0, suffix: '+', country: 'SINGAPORE', unis: 'Delft, Amsterdam, Eindhoven' },
    { flag: 'DUBAI.svg', alt: 'Dubai', target: 10, count: 0, suffix: '+', country: 'DUBAI', unis: 'Ireland, Sweden, Japan & more' },
  ];

  @ViewChild('admitsSection') admitsSection!: ElementRef;
  private observer: IntersectionObserver | null = null;
  private hasAnimated = false;

  ngAfterViewInit() {
    this.startAutoScroll();
    this.setupIntersectionObserver();
  }

  ngOnDestroy() {
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
    }
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  setupIntersectionObserver() {
    if (typeof IntersectionObserver !== 'undefined' && this.admitsSection) {
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !this.hasAnimated) {
            this.animateNumbers();
            this.hasAnimated = true;
          }
        });
      }, { threshold: 0.3 }); // Trigger when 30% of the section is visible
      
      this.observer.observe(this.admitsSection.nativeElement);
    }
  }

  animateNumbers() {
    const duration = 3000; // 3.5 seconds for a slower, smoother animation
    let startTimestamp: number | null = null;
    
    const step = (timestamp: number) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      
      // Use easeOutQuart for a very smooth deceleration
      const easeProgress = 1 - Math.pow(1 - progress, 4);
      
      this.admits.forEach(admit => {
        admit.count = Math.floor(easeProgress * admit.target);
      });
      
      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        this.admits.forEach(admit => {
          admit.count = admit.target; // Ensure final value is exact
        });
      }
    };
    
    window.requestAnimationFrame(step);
  }

  pauseScroll() {
    this.isPaused = true;
  }

  resumeScroll() {
    this.isPaused = false;
  }

  startAutoScroll() {
    const scrollStep = () => {
      if (this.testimonialContainer && !this.isPaused) {
        const container = this.testimonialContainer.nativeElement;
        
        // Add fractional or 1px scrolling
        container.scrollLeft += 1;
        
        // Reset when halfway to create infinite loop
        if (container.scrollLeft >= container.scrollWidth / 2) {
          container.scrollLeft = 0;
        }
      }
      this.animationFrameId = requestAnimationFrame(scrollStep);
    };
    this.animationFrameId = requestAnimationFrame(scrollStep);
  }
}
